// EventComponent.jsx
export const EventCards = ({ event }) => {
  const patientName =
    event.patientSurgery && event.patientSurgery.patient
      ? event.patientSurgery.patient.firstName +
        " " +
        event.patientSurgery.patient.lastName
      : null;

  return (
    <>
      <div>
        <strong>{event.title}</strong>
      </div>
      {patientName ? (
        <div style={{ fontSize: "0.85em" }}>Paciente: {patientName}</div>
      ) : (
        <div style={{ fontSize: "0.85em" }}>Disponible</div>
      )}
    </>
  );
};
